import { useCallback, useEffect, useState } from 'react';
import { classNameBlurred } from 'styles';

/**
 * Set or remove page content blur
 */
export const usePageBlur = () => {
  // Flag indicating if the page content is currently blurred
  const [pageBlurred, setPageBlurred] = useState(false);

  /**
   * Enable page content blur
   */
  const pageBlur = useCallback(() => setPageBlurred(true), []);

  /**
   * Disable page content blur
   */
  const pageUnblur = useCallback(() => setPageBlurred(false), []);

  // Toggle document body class name depending on the current blur state
  useEffect(() => {
    if (pageBlurred) {
      document.body.classList.add(classNameBlurred);
    } else {
      document.body.classList.remove(classNameBlurred);
    }
  }, [pageBlurred]);

  // Remove page blur when component unmounts
  useEffect(() => {
    return () => document.body.classList.remove(classNameBlurred);
  }, []);

  return {
    pageBlur,
    pageUnblur,
  };
};
